/**
 * These are used in paths.js
 * Which works via WithAuthorization -> isModuleAvailable() -> GLOBAL.organizationModules
 * AuthProvider sets this when you login.
 *
 * Minor TODO: refactor paths.js to use modules object
 */
const MODULES = {
  CarbonDashboard: {
    id: "CarbonDashboard",
  },
  NetZero: {
    id: "NetZero",
  },
  CarbonReporting: {
    id: "CarbonReporting",
  },
  DataCollection: {
    id: "DataCollection",
  },
  SupplierPortal: {
    id: "SupplierPortal",
  },
  CSRD: {
    id: "CSRD",
  },
  KnowledgeBase: {
    id: "KnowledgeBase",
  },
  AIR: {
    id: "AIR",
  },
  AIReporting: {
    id: "AIReporting",
  },
  CarbonInsightsDashboard: {
    id: "CarbonInsightsDashboard",
  },
  // placeholder for any future modules that are under development, so we can only show to internal orgs
  // UNDER_DEVELOPMENT code should be hidden from clients.
  // If a feature is ready to show to clients, then move it to a "proper" module.
  UNDER_DEVELOPMENT: {
    id: "UNDER_DEVELOPMENT",
  },
};

export default MODULES;
